import {JsonObject, JsonProperty} from 'json2typescript';
import {Theme} from '@app/order-assortment/model/theme/theme';
import {Comparable} from '@app/core/services/comparable';
import {isNil} from 'lodash';

@JsonObject('Theme')
export class ThemeImp extends Comparable<Theme> implements Theme {

  @JsonProperty('id', String)
  private _id: string = undefined;

  @JsonProperty('name', String)
  private _name: string = undefined;

  constructor(id?: string, name?: string) {
    super();
    this._id = id;
    this._name = name;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  equals(other: ThemeImp) {
    if (isNil(other)) {
      return false;
    }
    return this.id === other.id &&
        this.name === other.name;
  }
}
